const state = {
};

const getters = {
};

const actions = {
    GetEntityServersData({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.get_entity_servers_data', {
                entity_id: request_data,
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetPassword({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.get_server_password', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetDatabasePassword({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.get_database_password', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetServerDataForEdit({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.get_server_data', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    PostServerDataEdit({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.post_server_data', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id,
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    UpdatePackages({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.update_packages', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id,
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    UpdateToCentOSStream({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.update_to_centos_stream', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id,
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    RebootServer({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('servers_edit.reboot_server', {
                entity_id: request_data.entity_id,
                server_id: request_data.server_id,
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
};
